"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIBreadcrumbs = _interopRequireDefault(require("UIComponents/nav/UIBreadcrumbs"));

var _propTypes2 = require("FileManagerCore/constants/propTypes");

var _stringUtils = require("FileManagerCore/utils/stringUtils");

var FilePathBreadcrumbs = function FilePathBreadcrumbs(_ref) {
  var object = _ref.object,
      fullPath = _ref.fullPath;
  var parentFolderId = object.get('folder_id');

  if (!parentFolderId || !fullPath) {
    return null;
  }

  fullPath = (0, _stringUtils.removeLeadingSlashFromPath)(fullPath);
  var pathParts = fullPath.split('/');
  pathParts.pop();

  var renderFolder = function renderFolder(folderName, i) {
    return _react.default.createElement("span", {
      key: i
    }, folderName);
  };

  return _react.default.createElement(_UIBreadcrumbs.default, {
    className: "m-top-0 m-bottom-2",
    flush: true,
    singleBreadcrumbIsBackLink: false,
    wrapLevels: true
  }, pathParts.map(renderFolder));
};

FilePathBreadcrumbs.propTypes = {
  object: _propTypes2.mapProp.isRequired,
  fullPath: _propTypes.default.string
};
var _default = FilePathBreadcrumbs;
exports.default = _default;
module.exports = exports.default;